"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var projectApi_1 = __importDefault(require("./projectApi"));
var cloudApi_1 = __importDefault(require("./cloudApi"));
var settingsApi_1 = __importDefault(require("./settingsApi"));
var adminsApi_1 = __importDefault(require("./adminsApi"));
var backupApi_1 = __importDefault(require("./backupApi"));
var systemApi_1 = __importDefault(require("./systemApi"));
var pagesApi_1 = __importDefault(require("./pagesApi"));
var gitApi_1 = __importDefault(require("./gitApi"));
var boothApi_1 = __importDefault(require("./boothApi"));
var editorApi_1 = __importDefault(require("./editorApi"));
var notificationsApi_1 = __importDefault(require("./notificationsApi"));
var usersApi_1 = __importDefault(require("./usersApi"));
var bookingApi_1 = __importDefault(require("./bookingApi"));
var Api = /** @class */ (function () {
    function Api(url) {
        this.url = url;
        this.axios = axios_1.default.create({
            baseURL: url,
            timeout: 15000,
            headers: {
                'Content-Type': "application/json"
            }
        });
        this.cloudApi = new cloudApi_1.default(this.axios);
        this.projectApi = new projectApi_1.default(this.axios);
        this.settingsApi = new settingsApi_1.default(this.axios);
        this.adminsApi = new adminsApi_1.default(this.axios);
        this.backupApi = new backupApi_1.default(this.axios);
        this.systemApi = new systemApi_1.default(this.axios);
        this.pagesApi = new pagesApi_1.default(this.axios);
        this.gitApi = new gitApi_1.default(this.axios);
        this.boothApi = new boothApi_1.default(this.axios);
        this.editorApi = new editorApi_1.default(this.axios);
        this.notificationApi = new notificationsApi_1.default(this.axios);
        this.usersApi = new usersApi_1.default(this.axios);
        this.bookingApi = new bookingApi_1.default(this.axios);
    }
    Api.prototype.updateToken = function (token) {
        this.token = token;
        this.axios.defaults.headers['token'] = token;
    };
    Api.prototype.project_api = function () {
        return this.projectApi;
    };
    Api.prototype.cloud_api = function () {
        return this.cloudApi;
    };
    Api.prototype.git_api = function () {
        return this.gitApi;
    };
    Api.prototype.editor_api = function () {
        return this.editorApi;
    };
    Api.prototype.settings_api = function () {
        return this.settingsApi;
    };
    Api.prototype.admins_api = function () {
        return this.adminsApi;
    };
    Api.prototype.backup_api = function () {
        return this.backupApi;
    };
    Api.prototype.system_api = function () {
        return this.systemApi;
    };
    Api.prototype.booth_api = function () {
        return this.boothApi;
    };
    Api.prototype.pages_api = function () {
        return this.pagesApi;
    };
    Api.prototype.notification_api = function () {
        return this.notificationApi;
    };
    Api.prototype.users_api = function () {
        return this.usersApi;
    };
    Api.prototype.booking_api = function () {
        return this.bookingApi;
    };
    Api.prototype.login = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/admin/login", { username: username, password: password })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    Api.prototype.check = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/admin/check", { token: token })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    Api.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/admin/logout", { token: this.token })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    Api.prototype.change_password = function (current, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/admin/password", { password: password, current: current })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    return Api;
}());
exports.default = Api;
